<div [hidden]="!menuEnabled">
<div class="row justify-content-center mt-3 mb-3" *ngIf="showLoginForm">
    <div class="row col-md-7 col-11 login-box p-0 pb-2 login-backgroud" [formGroup]="form">
        <!--<div class="row mt-5">
            <div class="col-md-4 col-1"></div>
            <div class="col-md-5 col-10">
                <label class="lbl-type" translate>
                    <input type="radio" name="radioType" value="p" checked (change)="onTypeChange($event.target)">
                    Ordinary person
                </label>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4 col-1"></div>
            <div class="col-5">
                <label class="lbl-type" translate>
                    <input type="radio" name="radioType" value="c" (change)="onTypeChange($event.target)">
                    Juristic person
                </label>
            </div>
        </div>-->
        <div class="text-center col-12 col-md-12" style="padding-top: 15px;color: #007bff;">
            <h2>เข้าสู่ระบบ</h2>
        </div>
        <div class="col-sm-12 col-md-6">
            <div class="box-line-right">
                <div class="text-center" style="padding-top: 15px;color: #007bff;">
                    <h2>เข้าสู่ระบบด้วย Digital ID</h2>
                </div>
                <div class="btn btn-light btn-login-other ng-star-inserted" style="display: flex;align-items: center;margin-top: 23px;">
                    <div class="col-3 pl-0 pr-0 text-left">
                        <img class="icon-btn" height="30px" width="30px" src="../../assets/images/ThaID.png" />
                    </div>
                    <a class="col-9 text-login-other2 text-left" (click)="showAgreementDialog()"><span>แอปพลิเคชัน ThaID</span></a>
                </div>
            </div>        
        </div>
        <div class="col-sm-12 col-md-6 smDiv">
            <div class="text-center" style="padding-top: 15px;color: #007bff;">
                <h2>เข้าสู่ระบบ</h2>
            </div>
    
            <div class="row mt-4">
                <div class="col-md-4 col-2 text-right text-cust-blue">
                    <span class="fa fa-user"></span>
                </div>
                <div class="col-md-6 col-9">
                    <input type="text" class="form-control" placeholder="Username" formControlName="username">
                    <span class="text-danger"
                        *ngIf="(formControl.username.touched || submitted) && formControl.username.errors?.required">
                        กรุณาระบุ Username
                    </span>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-md-4 col-2 text-right text-cust-blue">
                    <span class="fa fa-lock"></span>
                </div>
                <div class="col-md-6 col-9">
                    <input type="password" class="form-control" placeholder="Password" formControlName="password">
                    <span class="text-danger"
                        *ngIf="(formControl.password.touched || submitted) && formControl.password.errors?.required">
                        กรุณาระบุ Password
                    </span>
                </div>
            </div>
    
            <div class="row mt-3">
                <div class="col-12 text-center">
                        <button class="btn btn-link" (click)="goToForgetPass(1)" translate>Forgot your password?</button>
                        <span>|</span>
                        <button class="btn btn-link" (click)="goToForgetPass(2)" translate>Forgot your username?</button>
                        <span *ngIf="regisMenu.show">|</span>
                        <button class="btn btn-link" *ngIf="regisMenu.show" (click)="goToRegister()" translate>Register</button>
                   
                </div>
            </div>
    
            <div class="row mt-3 justify-content-center">
                <div class="col-10 text-center">
                    <button class="btn btn-success btn-login" (click)="Login()">LOGIN</button>
                </div>
            </div>
        </div>
        <!-- <div *ngIf="!isCompany" class="row justify-content-center">
            <div class="col-md-2 col-0"></div>
            <div class="col-md-4 col-11 mt-3 text-center btn-social-login sr-only">
                <button class="btn btn-primary" (click)="fbLogin()">
                    <i class="fab fa-facebook"></i>
                    Login with Facebook
                </button>
            </div>
            <div class="col-md-2 col-11 mt-3 text-center btn-social-login sr-only">
                <div class="g-signin2 text-center" data-onsuccess="onSignIn"></div>
            </div>
            <div class="col-md-3 col-11 mt-3 text-center btn-social-login sr-only">
                <button class="btn btn-success btn-ln" (click)="lineLogin()">
                    <span class="fab fa-line"></span>
                    Line login
                </button>
            </div>
        </div> -->
    </div>
</div>

<div class="row justify-content-center mt-3 mb-3" *ngIf="showQRForm">
    <div class="row justify-content-center col-md-7 col-11 login-box pb-2 login-backgroud-QRForm" >
        <div class="rounded-lg-custom bgborder">
            <div class="radius4">
                <div class="pt-2 d-flex flex-column justify-center" style="text-align: center; font-family: Kanit;">
                    <div class="text-white">
                        <h1>เข้าสู่ระบบ</h1>
                        <div style="padding-left:56px !important">
                            <h5>ด้วย ThaID</h5>
                        </div>
                        <div style="padding-top:8px !important">
                            <h2>ระบบยื่นแบบผ่านอินเทอร์เน็ต</h2>  
                        </div>
                    </div>
                    <div class="pt-4 div-qrcode">
                        <img style="display: inline-block;" src="../../assets/images/DPA.png" width="300px" height="300px">
                    </div>
                </div>
            </div>
            <hr  role="separator" aria-orientation="horizontal" color="white" class="mt-2 v-divider theme--light">
            <div style="border-top-left-radius:inherit;border-top-right-radius:inherit;">
                <div class="pt-2 d-flex flex-column justify-center" style="text-align: center; color: white;">
                    <h5>คิวอาร์โค้ดนี้เป็นสิ่งยืนยันตนทางดิจิทัล ออกให้โดย</h5>
                    <h5>กรมการปกครอง กระทรวงมหาดไทย</h5>
                </div>
            </div>
        </div>
    </div>
</div>


<!-- OTP -->
<div class="mt-5 mb-3 border" *ngIf="showOtp">
    <div class="row text-center">
        <div class="col-12 col-sm-10 col-md-12">
            <div class="container">
                <div class="row mt-4 mb-4">
                    <div class="col-12 text-center">
                        <h4 class="text-cust-blue" translate>SMS-OTP</h4>
                    </div>
                </div>
                <div class="row mt-4 mb-4">
                    <div class="col-12 text-center">
                        <p translate>The SMS-OTP will sent to your registered mobile number.</p>
                        <p>
                            <label id="PhoneNo" style="color: red; font-size: 1.5rem;">{{telephoneOtp}}</label>
                        </p>
                        <p class="sr-only">กรุณาตรวจสอบ</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-center">
                        <label style="font-size: 1.1rem;">Reference Code: &nbsp;</label>
                        <label style="color: red; font-size: 1.5rem;">{{otpRef}}</label>
                    </div>
                </div>
                <div class="row m-2">
                    <div class="col-12 text-center">
                        <label style="font-size: 1.25rem;" translate>Please input your SMS-OTP password.</label>
                    </div>
                </div>
                <div class="row m-2 justify-content-center">
                    <div class="col-3">
                        <button type="button" class="btn btn-default w-100" [disabled]="disableResentOtp"
                            (click)="requestOtp()">{{requestOtpLbl}} {{otpTimer == 0 ? "" : otpTimer}}</button>
                    </div>
                </div>
                <div class="row m-2 justify-content-center">
                    <div class="col-3 text-center">
                        <input type="password" [(ngModel)]="otp" class="form-control" 
                            style="font-size: 1.1rem; text-align: center;" placeholder="{{'SMS-OTP' | translate}}">
                    </div>
                </div>
                <div class="row mt-4 mb-4 justify-content-center">
                    <div class="col-6 text-center">
                        <button type="button" class="btn btn-default mr-2" [disabled]="otp.trim().length == 0"
                            (click)="SubmitOTP()"><label translate>SendOTP</label>{{OTPCountDown}}</button>
                        <button type="button" class="btn btn-default ml-2" (click)="cancelOtp()" translate>CancelOTP</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- End OTP -->


<!-- dialog -->
<!-- aria-modal="true" style="display: block;"-->
<div class="modal fade modal-tabs modal-stack in show" role="dialog" tabindex="-1" aria-hidden="false" id="agreementDialog" >
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content py-3 clear-bg-color">
            <div class="form-group row px-2 mx-3">
                <div class="col-12 text-left ng-star-inserted">
                    <div class="title-font py-3">ข้อตกลงในการใช้บริการอิเล็กทรอนิกส์ของกรมสรรพากร </div>
                    <p style="text-indent: 2em;">
                        บริการอิเล็กทรอนิกส์ของกรมสรรพากร ซึ่งต่อไปนี้จะเรียกว่า "บริการอิเล็กทรอนิกส์” หมายถึง บริการที่กรมสรรพากรทำขึ้นเพื่ออำนวยความสะดวกให้กับประชาชนผู้มีหน้าที่เสียภาษีอากร ผู้มีหน้าที่นำส่งภาษี ผู้ประกอบการจดทะเบียน หรือบุคคลใด ด้วยกระบวนการทางอิเล็กทรอนิกส์ ซึ่งต่อไปนี้จะเรียกว่า “ผู้ขอใช้บริการ” ให้สามารถขอใช้บริการผ่านระบบอิเล็กทรอนิกส์เพื่อยื่นแบบแสดงรายการภาษี แบบยื่นรายการนำส่งภาษี แบบยื่นรายการภาษี แบบนำส่งภาษี รายงาน บัญชีพิเศษ บัญชีงบดุลหรือบัญชีอื่น ๆ ประกอบแบบแสดงรายการ คำร้องคืนภาษีอากร คำอุทธรณ์ คำร้อง คำขอ หรือเอกสารหรือหนังสืออื่นใดให้กรมสรรพากร ซึ่งรวมถึงบริการอิเล็กทรอนิกส์อื่นใดที่กรมสรรพากรกำหนดให้มีขึ้นทั้งที่ได้กำหนดไว้แล้วในขณะนี้และที่จะกำหนดให้มีขึ้นในอนาคต โดยผู้ขอใช้บริการตกลงที่จะผูกพันและปฏิบัติตามเงื่อนไขในการใช้บริการ ดังต่อไปนี้ 
                    </p>
                    <ol>
                        <li> ผู้ขอใช้บริการตกลงขอใช้บริการอิเล็กทรอนิกส์ และกรมสรรพากรตกลงให้บริการอิเล็กทรอนิกส์ ซึ่งการให้บริการอิเล็กทรอนิกส์นี้เกี่ยวเนื่องกับภารกิจการจัดเก็บภาษีอากรของกรมสรรพากร ตามประมวลรัษฎากร </li>
                        <li><p> การพิสูจน์และยืนยันตัวตนในการใช้บริการอิเล็กทรอนิกส์ของกรมสรรพากร สามารถดำเนินการผ่านระบบการพิสูจน์และยืนยันตัวตนทางดิจิทัล DOPA-Digital ID ผ่านแอปพลิเคชัน ThaID ของกรมการปกครอง ทั้งนี้ ผู้ขอใช้บริการศึกษารายละเอียดเพิ่มเติมได้ที่ https://www.bora.dopa.go.th/app-d-dopa </p></li>
                        <li>
                            <p>เมื่อผู้ขอใช้บริการได้ยืนยันตัวตนทางดิจิทัลผ่านแอปพลิเคชัน ThaID เพื่อเข้าใช้บริการอิเล็กทรอนิกส์ของกรมสรรพากรแล้ว ตกลงที่จะผูกพันและปฏิบัติ ตามเงื่อนไขดังต่อไปนี้</p>
                            <ol>
                                <li style="list-style-type: none;">
                                    3.1 การยื่นแบบแสดงรายการและชำระภาษี
                                </li>
                                <ol>
                                    <li style="text-indent: 29px; list-style-type:none;">
                                        (1) เมื่อผู้ขอใช้บริการได้ยืนยันการส่งข้อมูลและกรมสรรพากรตอบรับการยื่นรายการข้อมูลตามแบบแสดงรายการและรับชำระภาษีอากร (ถ้ามี) ดังกล่าวแล้ว ถือว่าเป็นการทำรายการโดยผู้ขอใช้บริการ และผู้ขอใช้บริการยอมรับที่จะผูกพันในรายการนั้นว่าเป็นการยื่นแบบและการชำระภาษีอากรของผู้ขอใช้บริการนั้นเอง และรับรองว่ารายการข้อมูลดังกล่าวถูกต้องเป็นจริงทุกประการ รวมถึงยอมรับผลผูกพันตามข้อมูลในแบบที่จัดพิมพ์ขึ้นโดยระบบคอมพิวเตอร์ในรายการข้อมูลตามการยื่นแบบและชำระภาษีอากรทางอิเล็กทรอนิกส์ 
                                    </li>
                                    <li style="text-indent: 29px; list-style-type:none;">
                                        (2) ผู้ขอใช้บริการจะต้องยื่นแบบและชำระภาษีอากร (ถ้ามี) ภายในกำหนดเวลาตามกฎหมาย โดยจะต้องชำระภาษีอากรผ่านหน่วยรับชำระภาษีอากร และช่องทางการชำระภาษีอากรที่กรมสรรพากรกำหนด ทั้งนี้ การชำระเงินต้องชำระภายในกำหนดเวลาของแต่ละหน่วยรับชำระภาษีอากร และช่องทางการชำระภาษีด้วย กรณีผู้ขอใช้บริการยื่นแบบและชำระภาษีอากร (ถ้ามี) เกินกำหนดเวลา ของแต่ละหน่วยรับชำระภาษีอากร และช่องทางการชำระภาษีอากรผู้ขอใช้บริการยอมรับว่าเป็นการยื่นแบบแสดงรายการและชำระภาษีอากรในวันถัดไป กรณีผู้ขอใช้บริการยื่นแบบและชำระภาษีอากร (ถ้ามี) เกินกำหนดเวลาตามกฎหมาย ผู้ขอใช้บริการยอมรับที่จะชำระเบี้ยปรับ (ถ้ามี) เงินเพิ่มภาษีอากร (ถ้ามี) และค่าปรับทางอาญา (ถ้ามี) ซึ่งถูกคำนวณอัตโนมัติตามหลักเกณฑ์ที่กฎหมายกำหนดโดยระบบบริการอิเล็กทรอนิกส์ของกรมสรรพากร 
                                    </li>
                                    <li style="text-indent: 29px; list-style-type:none;">
                                        (3) จำนวนเงินที่ผู้ขอใช้บริการชำระภาษีอากรหรือนำส่ง ต้องมีจำนวนเท่ากับจำนวนภาษีอากร (ถ้ามี) เบี้ยปรับ (ถ้ามี) เงินเพิ่มภาษีอากร (ถ้ามี) และค่าปรับทางอาญา (ถ้ามี) ที่ต้องชำระตามหลักเกณฑ์ที่กฎหมายกำหนด 
                                    </li>
                                    <li style="text-indent: 29px; list-style-type:none;">
                                        (4) กรณีที่ธนาคารแจ้งว่าจำนวนเงินในบัญชีเงินฝากของผู้ขอใช้บริการมีไม่เพียงพอสำหรับการชำระภาษีอากร (ถ้ามี) เบี้ยปรับ (ถ้ามี) เงินเพิ่มภาษีอากร (ถ้ามี) และค่าปรับทางอาญา (ถ้ามี) ตามแบบ หรือผู้ขอใช้บริการมิได้ชำระภาษีอากร (ถ้ามี) เบี้ยปรับ (ถ้ามี) เงินเพิ่มภาษีอากร (ถ้ามี) และค่าปรับทางอาญา (ถ้ามี) ตามแบบ จะถือว่าไม่มีการยื่นแบบในครั้งนั้น 
                                    </li>
                                    <li style="text-indent: 29px; list-style-type:none;">
                                        (5) การยื่นแบบและชำระภาษีอากรทางอิเล็กทรอนิกส์ของผู้ขอใช้บริการ เป็นอันเสร็จสมบูรณ์เมื่อผู้ขอใช้บริการได้รับใบเสร็จรับเงิน หรือหลักฐานอื่นใด เป็นข้อมูลอิเล็กทรอนิกส์ซึ่งได้ลงลายมือชื่ออิเล็กทรอนิกส์ หรือหลักฐานอื่นใดจากกรมสรรพากร 
                                    </li>
                                    <li style="text-indent: 29px; list-style-type:none;">
                                        (6) กรณีที่เกิดเหตุขัดข้องเป็นเหตุให้มีการหยุดการรับแบบและรับชำระภาษีอากร (ถ้ามี) เป็นการชั่วคราว หรือกรณีอื่นใดที่ทำให้ผู้ขอใช้บริการไม่สามารถยื่นแบบและชำระภาษีอากร (ถ้ามี) ทางอิเล็กทรอนิกส์ได้ ผู้ขอใช้บริการยังคงมีหน้าที่ต้องไปยื่นแบบและชำระภาษีอากร (ถ้ามี) ณ สำนักงานสรรพากรพื้นที่สาขา หรือผ่านช่องทางอื่นใดที่กรมสรรพากรกำหนด 
                                    </li>
                                    <li style="text-indent: 29px; list-style-type:none;">
                                        (7) การยื่นแบบและชำระภาษีอากรทางอิเล็กทรอนิกส์เป็นเพียงระบบการให้บริการที่อำนวยความสะดวกในการยื่นแบบและชำระภาษีอากร ไม่มีผลทำให้ผู้ขอใช้บริการหลุดพ้นจากหน้าที่และความรับผิดตามบทบัญญัติแห่งประมวลรัษฎากร 
                                    </li>
                                </ol>
                                <li style="list-style-type: none;">
                                    3.2 ข้อจำกัดความรับผิด
                                </li>
                                <ol>
                                    <li style="text-indent: 29px; list-style-type:none;">
                                        (1) ผู้ขอใช้บริการยอมรับว่าการกระทำใด ๆ ผ่านระบบบริการอิเล็กทรอนิกส์ของกรมสรรพากร เป็นไปเพื่อวัตถุประสงค์ในการใช้บริการต่าง ๆ ของผู้ขอใช้บริการเท่านั้น หากผู้ขอใช้บริการหรือบุคคลใดโดยใช้ชื่อผู้ใช้งาน (User ID) และรหัสผ่าน (Password) ของผู้ขอใช้บริการ ได้กระทำการใดอันก่อให้เกิดความเสียหายแก่กรมสรรพากรหรือบุคคลอื่นใด ผู้ขอใช้บริการจะต้องรับผิดชอบต่อการกระทำการข้างต้นทุกประการ 
                                    </li>
                                    <li style="text-indent: 29px; list-style-type:none;">
                                        (2) ผู้ขอใช้บริการตกลงจะไม่ใช้ระบบบริการอิเล็กทรอนิกส์ของกรมสรรพากรเพื่อวัตถุประสงค์ทางการค้า หรือดำเนินการใด ๆ ที่เป็นการกระทำที่ขัดต่อกฎหมาย หรือศีลธรรมอันดีของประชาชนผ่านระบบบริการอิเล็กทรอนิกส์ของกรมสรรพากร ซึ่งรวมถึงแต่ไม่จำกัดเพียงการไม่ส่งหรือเผยแพร่โปรแกรมไวรัสหรือโปรแกรมอื่นใดที่ออกแบบมาเพื่อขัดขวาง ทำลาย หรือทำให้เสียหายซึ่งโปรแกรมคอมพิวเตอร์ อุปกรณ์โทรคมนาคม หรืออุปกรณ์อื่น ๆ ทั้งนี้ ผู้ขอใช้บริการต้องรับผิดชอบต่อกรมสรรพากรหรือบุคคลใด สำหรับความเสียหายที่เกิดขึ้นจากกรณีดังกล่าวทุกประการ 
                                    </li>
                                    <li style="text-indent: 29px; list-style-type:none;">
                                        (3) ผู้ขอใช้บริการเข้าใจและรับทราบว่าข้อมูลส่วนบุคคลที่ได้กรอกลงทะเบียนสมัครใช้บริการอิเล็กทรอนิกส์ของกรมสรรพากรนี้จะถูกส่งผ่านเครือข่ายอิเล็กทรอนิกส์ซึ่งเป็นเครือข่ายสาธารณะ โดยผู้ขอใช้บริการจะใช้ความระมัดระวัง และกำหนดมาตรการเพื่อป้องกันมิให้บุคคลภายนอกเข้าถึงข้อมูลส่วนบุคคลดังกล่าวได้ 
                                    </li>
                                    <li style="text-indent: 29px; list-style-type:none;">
                                        (4) การจัดเก็บข้อมูลส่วนบุคคลของผู้ขอใช้บริการ กรมสรรพากรจะดำเนินการเท่าที่จำเป็นในการเก็บรักษาข้อมูลส่วนบุคคลภายใต้มาตรฐานในการรักษาความปลอดภัยอย่างเคร่งครัด เพื่อปกป้องความเสียหาย หรือการเข้าถึงข้อมูลส่วนบุคคลโดยไม่มีอำนาจ ทั้งนี้ จะมีกระบวนการในการแก้ไข ปรับปรุงข้อมูลให้ถูกต้อง เป็นปัจจุบัน และมีความสมบูรณ์ตามมาตรฐานในการให้บริการ 
                                    </li>
                                    <li style="text-indent: 29px; list-style-type:none;">
                                        (5) ผู้ขอใช้บริการยืนยันว่าข้อมูลที่อยู่ในระบบบริการอิเล็กทรอนิกส์ของผู้ขอใช้บริการเป็นข้อมูลที่มีความเป็นปัจจุบัน และเป็นหน้าที่ของผู้ขอใช้บริการในการแก้ไขเปลี่ยนแปลงข้อมูลดังกล่าว 
                                    </li>
                                    <li style="text-indent: 29px; list-style-type:none;">
                                        (6) การบริการอิเล็กทรอนิกส์ของกรมสรรพากร เป็นเพียงบริการที่กรมสรรพากรทำขึ้นเพื่อเป็นช่องทางในการอำนวยความสะดวกให้กับประชาชนในการดำเนินการต่าง ๆ ตามที่ได้กล่าวมาในข้างต้น ผู้ขอใช้บริการตกลงว่า กรมสรรพากรจะไม่รับผิดชอบจากการที่กรมสรรพากรไม่สามารถปฏิบัติตามข้อตกลงนี้ได้ หรือจากความสูญเสียหรือเสียหายใด ๆ ไม่ว่าโดยตรงหรือโดยอ้อม รวมถึงความสูญเสียหรือความเสียหายกรณีพิเศษ อันเกิดจากการใช้บริการอิเล็กทรอนิกส์ดังกล่าว โดยรวมถึงแต่ไม่จำกัดอยู่เพียงเหตุสุดวิสัย เช่น ในกรณีที่ระบบอิเล็กทรอนิกส์เกิดความล่าช้าหรือมีเหตุขัดข้อง ไวรัสคอมพิวเตอร์ ไฟไหม้ น้ำท่วม หรือเหตุการณ์อื่น ๆ ที่กรมสรรพากรไม่สามารถควบคุมดำเนินการได้โดยตรง 
                                    </li>
                                    <li style="text-indent: 29px; list-style-type:none;">
                                        (7) กรณีที่ผู้ขอใช้บริการมิได้ปฏิบัติตามเงื่อนไขที่กรมสรรพากรกำหนด กรมสรรพากรจะสั่งเพิกถอนสิทธิการใช้บริการอิเล็กทรอนิกส์ของกรมสรรพากร 
                                    </li>
                                    <li style="text-indent: 29px; list-style-type:none;">
                                        (8) กรมสรรพากรขอสงวนสิทธิในการยกเลิกบริการนี้ หรือแก้ไขเปลี่ยนแปลงข้อตกลงในการใช้บริการอิเล็กทรอนิกส์ของกรมสรรพากรได้ โดยไม่จำเป็นต้องแจ้งให้ผู้ขอใช้บริการทราบล่วงหน้า 
                                    </li>
                                </ol>
                            </ol>
                        </li>
                    </ol>
                </div>
            </div>
            <div class="row justify-content-center mb-2 ng-star-inserted">
                <button class="btn btn-secondary-new" type="button" data-dismiss="modal" aria-label="Close">กลับหน้าหลัก</button>
                <a class="btn btn-login ml-3" type="button"  data-dismiss="modal" aria-label="Close" (click)="btnAgreement()">ยอมรับ</a>
            </div>
        </div>
    </div>
</div>

<!-- End dialog -->
</div>


// WEBPACK FOOTER //
// ./src/app/account/login/login.component.html